// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eNsBv","field":"styles_field__3dz-F","fieldCol":"styles_fieldCol__1d01y","diffCol":"styles_diffCol__1SY4j","diff":"styles_diff__1tNxg"};